import { useMemo } from "react";
import { IntlProvider } from "react-intl";

import { useTeams } from "@/teams";
import { logIntlError } from "@/intl";

import { SUPPORTED_LOCALES, getLocaleMessages } from "./locales";
import resolveLocale from "./resolveLocale";

export interface LocaleProviderProps {
  children: React.ReactNode;
}

/**
 * Localizes the app to the language the recruiter uses in Teams, falling back
 * to the browser language outside of Teams.
 */
export default function LocaleProvider({ children }: LocaleProviderProps) {
  const teams = useTeams();
  const teamsLocale = teams.inTeams ? teams.context.app.locale : null;

  const locale = useMemo(
    () => resolveLocale([teamsLocale, navigator.language], SUPPORTED_LOCALES),
    [teamsLocale],
  );

  return (
    <IntlProvider
      locale={locale}
      defaultLocale="en"
      messages={getLocaleMessages(locale)}
      defaultRichTextElements={{
        strong: (chunks) => <strong>{chunks}</strong>,
      }}
      onError={logIntlError}
    >
      {children}
    </IntlProvider>
  );
}
